<template>
  <div class="product-dropdown" ref="dropdown">
    <span class="dropdown-trigger" @click="toggleDropdown">
      <i class="ico ico-microsoft"></i>
      <span>{{ t('header.departments') || 'Departments' }}</span>
    </span>
    <transition name="fade">
      <div class="dropdown-content" v-if="isOpen" @click.stop>
        <!-- <div class="dropdown-section">
          <h4>{{ t('dropdown.specialEvents.title') || '特色活动' }}</h4>
          <ul>
            <li v-for="event in specialEvents" :key="event.id">
              <router-link :to="event.path" class="event-item">
                <span class="text">{{ event.name }}</span>
              </router-link>
            </li>
          </ul>
        </div> -->
        <div class="dropdown-section">
          <h4>{{ t('dropdown.categories.title') || '商品分类' }}</h4>
          <div class="categories-container">
            <ul class="categories-list">
              <li v-for="category in categories" :key="category.id" class="category-item-container">
                <div class="category-item" @click="toggleSubmenu(category.id)" :class="{ 'active': activeCategory === category.id }">
                  <span class="text">{{ getCategoryName(category.name) }}</span>
                  <span class="submenu-icon">></span>
                </div>
                <transition name="fade">
                  <div v-if="activeCategory === category.id" class="submenu">
                    <ul>
                      <li v-for="sub in category.children" :key="sub.id" class="submenu-item-container">
                        <div class="submenu-item" @click="(e) => {
                          e.stopPropagation();
                          if (sub.children?.length) {
                            toggleSubSubmenu(sub.id);
                          } else {
                            toggleDropdown();
                            router.push({
                              path: '/shop',
                              query: { categoryId: sub.id }
                            });
                          }
                        }" :class="{ 'active': activeSubcategory === sub.id }">
                          <span class="text">{{ getCategoryName(sub.name) }}</span>
                          <span v-if="sub.children?.length" class="submenu-icon">></span>
                        </div>
                        <transition name="fade">
                          <div v-if="activeSubcategory === sub.id && sub.children?.length" class="subsubmenu">
                            <ul>
                              <li v-for="subsub in sub.children" :key="subsub.id">
                                <router-link :to="{ path: '/shop', query: { categoryId: subsub.id } }" class="submenu-item" @click="toggleDropdown">
                                  <span class="text">{{ getCategoryName(subsub.name) }}</span>
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </transition>
                      </li>
                    </ul>
                  </div>
                </transition>
              </li>
            </ul>
          </div>
        </div>
        <div class="dropdown-section">
          <ul class="categories-list">
            <li class="alldepartments" @click="toggleDropdown">
              <router-link :to="'/allDepartments'">
                <span class="text">{{ t('dropdown.allDepartments') }}</span>
              </router-link>
            </li>
            <li class="close" @click="toggleDropdown">
              <span class="icon-text">
                <FontAwesomeIcon :icon="faXmark" class="icon" />
                <span>{{ t('dropdown.close') }}</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { categoryList } from '@/api/categoryList';

const { t, locale } = useI18n();
const router = useRouter();
const isOpen = ref(false);
const dropdown = ref(null);
const activeCategory = ref(null);
const activeSubcategory = ref(null);
function toggleSubmenu(categoryId) {
  activeCategory.value = activeCategory.value === categoryId ? null : categoryId;
  activeSubcategory.value = null;
}

function toggleSubSubmenu(subcategoryId) {
  activeSubcategory.value = activeSubcategory.value === subcategoryId ? null : subcategoryId;
}
// 示例数据，实际使用时应从后端获取
const specialEvents = [
  { id: 1, name: t('dropdown.specialEvents.events[0].name'), path: '/events/summer-sale' },
  { id: 2, name: t('dropdown.specialEvents.events[1].name'), path: '/events/new-arrivals' },
  { id: 3, name: t('dropdown.specialEvents.events[2].name'), path: '/events/time-limited' }
];



const categories = ref([])
const currentLang = computed(() => locale.value === 'en' ? 'en-US' : 'zh-CN');

// 监听语言切换事件
const updateCurrentLang = async (lang) => {
  currentLang.value = lang

}

// 监听语言切换事件
window.addEventListener('languageChange', (event) => {
  const newLang = event.detail.lang
  updateCurrentLang(newLang)
})

// 获取当前语言的翻译
const getCategoryName = (name) => {
  try {
    const translations = JSON.parse(name)
    return translations[currentLang.value]
  } catch (error) {
    // 如果解析失败，直接返回原始值
    return name
  }
}

const fetchCategories = async () => {
  try {
    const response = await categoryList({ type: 1 });
    if (response && response.data) {
      categories.value = response.data;
    }
  } catch (error) {
    console.error('Error fetching categories:', error);
  }
};

function toggleDropdown() {
  isOpen.value = !isOpen.value;
}

// 处理点击外部关闭下拉菜单
function handleClickOutside(event) {
  if (dropdown.value && !dropdown.value.contains(event.target)) {
    isOpen.value = false;
  }
}

// 添加事件监听器
onMounted(() => {
  fetchCategories();
  document.addEventListener('click', handleClickOutside);
});

// 移除事件监听器
onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped lang="scss">
.product-dropdown {
  position: relative;
  display: inline-block;
  color: #000000;
  cursor: pointer;
  :hover{
    color: #fb6e01;
  }
  .dropdown-trigger {
    display: flex;
    align-items: center;
    gap: 4px;
    span{
      height: 1.7rem;
    font-size: 1.2rem;
    }
  }
  .ico-microsoft:before {
    content: "\ebb5";
    font-size: 1.6rem;
}
  .alldepartments{
    color: #333;
    padding: 8px 12px;
    a{
      color: #333;
    }
  }
  .close{
    color: #0041c7;
    padding: 8px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .close .icon {
    font-size: 16px;
    color: #0041c7;
    margin-right: 5px;
  }
  .dropdown-content {
    position: absolute;
    top: 139%;
    left: 0;
    background-color: white;
    padding: 15px;
    margin-top: 8px;
    min-width: 300px;
    height: 558px;
    z-index: 1000;
    border: 1px solid;
    font-size: 1rem;

    .dropdown-section {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
      .event-item{
        color: #333;
        font-size: 14px;
      }
      li{
       margin: 0; 
      }

      h4 {
        color: #333;
        font-size: 16px;
        margin-bottom: 12px;
        font-weight: 600;
      }

      .categories-container {
        display: flex;
        gap: 12px;
      }

      .categories-list {
        list-style: none;
        padding: 0;
        width: 100%;
      }

      .category-item-container {
        margin-bottom: 0;
      }

      .category-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        border-radius: 4px;
        text-decoration: none;
        color: #333;
        width: 100%;
        cursor: pointer;
        
        &:hover, &.active {
          background-color: #f5f5f5;
          color: #fb6e01;
        }


        .icon {
          font-size: 18px;
        }

        .submenu-icon {
          font-size: 12px;
          font-weight: bold;
          margin-left: auto;
          transition: transform 0.2s ease;
        }

        &.active .submenu-icon {
          // transform: rotate(180deg);
        }
      }

      .submenu {
        position: absolute;
        top: 0;
        left: 100%;
        background-color: white;
        padding: 8px;
        margin-left: 1px;
        min-width: 358px;
        height: 557px;
        z-index: 1001;
        border: 1px solid;
        border-left: 0;

        ul {
          list-style: none;
          padding: 0;
          height: 100%;
          overflow: auto;
          scrollbar-width: none;
          &::-webkit-scrollbar {
            display: none;
          }
        }
        li{
          margin: 0;
        }

        .submenu-item {
          display: flex;
          padding: 6px 12px;
          border-radius: 4px;
          text-decoration: none;
          color: #333;
        
          width: 100%;
          
          &:hover, &.active {
          background-color: #f5f5f5;
          color: #fb6e01;
        }


        .icon {
          font-size: 18px;
        }

        .submenu-icon {
          font-size: 12px;
          font-weight: bold;
          margin-left: auto;
          transition: transform 0.2s ease;
        }
        }
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.subsubmenu {
  position: absolute;
  top: 0;
  left: 100%;
  width: 340px;
  background: white;
  border: 1px solid;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  padding: 8px 0;
  z-index: 1000;
  height: 100%;
}
</style>
